export default () => <div className="loading" />;
